import { BrandliveEventListItem } from '@/types/projects.types';
import { Get } from '../helpers';

export function GetProjectsFullList(channel: number): Promise<BrandliveEventListItem[]> {
  return Get({ path: `/v3/admin/events/full/${channel}` });
}
